var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpendableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9308 0.84375C11.6579 0.84375 11.3361 0.899774 10.8965 1.01613C9.79041 1.30775 3.30452 3.10196 3.20828 3.13069C2.24581 3.49269 1.63672 3.84895 1.25461 4.26841C1.7028 3.96531 2.23719 3.77425 2.84053 3.77425H13.1375V2.54459C13.1375 1.94987 13.1332 0.84375 11.9308 0.84375ZM2.84053 4.50975C1.47296 4.50975 0.634033 5.79543 0.634033 6.71624V14.5769C0.634033 15.716 1.56346 16.6455 2.70262 16.6455H14.0109C15.1501 16.6455 16.0795 15.716 16.0795 14.5769V6.65878C16.0795 5.53399 15.028 4.50975 13.873 4.50975H2.84053ZM13.3214 9.65823C13.8285 9.65823 14.2407 10.0691 14.2407 10.5776C14.2407 11.0861 13.8285 11.497 13.3214 11.497C12.8128 11.497 12.402 11.0861 12.402 10.5776C12.402 10.0691 12.8128 9.65823 13.3214 9.65823Z",
    fill: "#D12222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendableIcon);
export default __webpack_public_path__ + "static/media/spendable_icon.581e6a320d0d594182405e991e176d16.svg";
export { ForwardRef as ReactComponent };